import { z } from 'zod';

export const unleashEvent = z.object({
  id: z.number().min(0),
  createdAt: z.coerce.date(),
  type: z.enum([
    'feature-created',
    'feature-updated',
    'feature-deleted',
    'feature-archived',
    'feature-revived',
    'feature-metadata-updated',
    'feature-project-change',
    'feature-import',
    'feature-tagged',
    'feature-untagged',
    'feature-tag-import',
    'feature-strategy-add',
    'feature-strategy-update',
    'feature-strategy-remove',
    'feature-stale-on',
    'feature-stale-off',
    'feature-environment-enabled',
    'feature-environment-disabled',
    'drop-features',
    'drop-feature-tags',
    'feature-potentially-stale-on',
    'strategy-created',
    'strategy-updated',
    'strategy-deleted',
    'strategy-deprecated',
    'strategy-reactivated',
    'strategy-import',
    'drop-strategies',
    'context-field-created',
    'context-field-updated',
    'context-field-deleted',
    'project-created',
    'project-updated',
    'project-deleted',
    'project-import',
    'drop-projects',
    'tag-created',
    'tag-deleted',
    'tag-import',
    'drop-tags',
    'tag-type-created',
    'tag-type-updated',
    'tag-type-deleted',
    'tag-type-import',
    'drop-tag-types',
    'addon-config-created',
    'addon-config-updated',
    'addon-config-deleted',
    'user-created',
    'user-updated',
    'user-deleted',
    'environment-import',
    'drop-environments',
    'segment-created',
    'segment-updated',
    'segment-deleted',
    'suggest-change-created',
    // does not exist in documentation, but exists in event history
    'strategy-order-changed',
  ]),
  createdBy: z.string(),
  project: z.string().nullish(),
  environment: z.string().nullish(),
  featureName: z.string().nullish(),
  data: z.unknown().nullish(),
  preData: z.unknown().nullish(),
  tags: z
    .array(
      z.object({
        value: z.string(),
        type: z.string(),
      }),
    )
    .nullish(),
});
export type UnleashEvent = z.infer<typeof unleashEvent>;
